import React, { useEffect, useState } from "react";
import Select from "react-select";
import { RSelect_Styles } from "../Class/Class_Etc";
import makeAnimated from "react-select/animated";

//Add By Sittiron : 2023-08-17

// Edit By POOM : 2023-10-09
//  เพิ่มการ ให้ เลือก value บางอย่าง ตั้งแต่แรกสุด
//  โดยเพิ่ม Parameter Valueshow , setvalueSelect

// การใช้งาน props
// API_URL                = url API  โดย นำมาจากค่า configData.API_URL

// resetSelect            = ส่ง ตัวแปร useState เข้ามา เพราะ ถ้า  ตัวแปร useState นั้นถูกเปลี่ยนแปลงค่าเมื่อไหร่ จะทำให้ ค่า select ถูก Reset
// resetSelect2           = ส่ง ตัวแปร useState เข้ามา เพราะ ถ้า  ตัวแปร useState นั้นถูกเปลี่ยนแปลงค่าเมื่อไหร่ จะทำให้ ค่า select ถูก Reset
//                          ใช้สำหรับ ถ้าต้องการให้ reset แยกจากตัวอื่น

// onChangevalue          = ส่ง function เข้ามา เพื่อตอน เลือกค่าใน select จะได้ return event กลับไปยัง function ข้างนอก
//                        = เพื่อให้ function ข้างนอกนั้น เอาไป set ค่าใช้งานอีกที
//                        = โดยจะเป็น function ที่ รับ parameter 1 ตัวเท่านั้น
//SelectTextDefault      = ค่าแรกสุดที่เป็น value -1 หรือ PlaceHolder
//iscloseMenuOnSelect    = true , false เพื่อบอกว่า  เมื่อมีการเลือก ข้อมูล select แล้ว ตัวกล่อง select จะถูกปิด หรือ เปิดค้างไว้
//                        = true เหมาะสำหรับ selectismulti = true
//                        = false เหมาะสำหรับ selectismulti = false
// refid                  = การอ้างอิง

// isDisabled             = true = ปิดไม่ให้เลือก , false = เปิดให้เลือกตามปกติ

// Valueshow              = ส่งมาเป็น value เลย  เช่น  1 หรือ 1,2,5  หรือ  2,4,7,2  ประมาณนี้
// setvalueSelect         = ส่ง ตัวแปร useState เข้ามา เพราะ ถ้า  ตัวแปร useState นั้นถูกเปลี่ยนแปลงค่าเมื่อไหร่ จะทำให้ ค่า select ถูก set ตาม Valueshow

function Select_TaskMultiGroup(props) {
  const {
    API_URL,
    resetSelect,
    resetSelect2,
    onChangevalue,
    SelectTextDefault,
    iscloseMenuOnSelect,
    refid,
    isDisabled,
    Valueshow,
    setvalueSelect,
  } = props;

  const [isFirst, setIsFirst] = useState(true);
  const [listTaskDDL, setListTaskDDL] = useState([]);
  const [listTaskShow, setListTaskShow] = useState([]);
  const [selectedOptionsTask, setSelectedOptionsTask] = useState([]);
  const animatedComponents = makeAnimated();

  useEffect(() => {
    if (isFirst) {
      BindDDL_Task();
      setIsFirst(false);
    }
    // eslint-disable-next-line
  }, [isFirst]);

  useEffect(() => {
    if (resetSelect) {
      setSelectedOptionsTask([]);
      onChangevalue(null);
      setListTaskShow(listTaskDDL);
    }
    // eslint-disable-next-line
  }, [resetSelect]);

  useEffect(() => {
    if (resetSelect2) {
      setSelectedOptionsTask([]);
      onChangevalue(null);
      setListTaskShow(listTaskDDL);
    }
    // eslint-disable-next-line
  }, [resetSelect2]);

  useEffect(() => {
    if (setvalueSelect) {
      try {
        if (Valueshow.length > 0) {
          let arr = [];
          let arrValueshow = Valueshow.split(",");
          for (let i = 0; i < arrValueshow.length; i++) {
            
            listTaskShow.filter((e) => parseInt(e.value) === parseInt(arrValueshow[i]))
              .map((en) => {
                return arr.push({
                  value: en.value,
                  label: en.label,
                  parent_id : en.parent_id,
                });
              });
          }
          DDLTaskOptionChange(arr)
        }
      } catch {}
    }
    // eslint-disable-next-line
  }, [setvalueSelect]);

  async function BindDDL_Task(_callback) {
    try {
      let token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = "";

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(API_URL + "Task_GetDDL", requestOptions);

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          setListTaskDDL(json.data);
          setListTaskShow(json.data);
        } else {
          setListTaskDDL([]);
        }
        if (_callback != null) {
          _callback();
        }
      }
      else {
        setListTaskDDL([]);
        if (_callback != null) {
          _callback();
        }
      }
    } catch {
      setListTaskDDL([]);
      if (_callback != null) {
        _callback();
      }
    }
  }

  const DDLTaskOptionChange = (selected) => {
    /// ตรวจสอบจุดแรกว่า ใน txtbox Selected มี value หรือไม่หากไม่มีจะ Dropdownn list จะกลับมาเป็นค่า Default คือมีค่าใน List ดั่งเดิม
    if (selected.length === 0) {
      document.getElementById("hd_selected_parent").value = "";
      setListTaskShow(listTaskDDL);
      setSelectedOptionsTask([]);
      onChangevalue(null);
    } else {
      /// ประกาศตัวเพื่อรับค่าตัวเช็ค ว่าตัว Select ล่าสุดเป็น Task แม่หรือลูก
      const last_parent_selected = selected[selected.length - 1].parent_id;
      /// หากตรวจพบเป็นการ Select ลูกจะเข้าทำงานดังข้างล่างนี้
      if (last_parent_selected !== 0) {
        /// เริ่มจากล่างค่าจาก hidden filed ก่อน และเขียนทับใหม่ทีหลัง
        document.getElementById("hd_selected_parent").value = "";
        /// เอาค่า Selected ลูกที่เลือกมาใส่ใน txtbox ไว้
        setSelectedOptionsTask(selected);
        onChangevalue(selected);
        /// เอาค่า Selected  เข้า Function Loop เอา Parent_id มาต่อ String และ เก็บในตัวแปร textparent
        let textparent = cutparent(selected);
        /// เอา textparent มาแตก String ออก และ เก็บในตัวแปร valuesparent
        const valuesparent = textparent.split(",");
        /// เอา valuesparent ตัดคำซ้ำออก สมมุติจาก 98,98,98,98,5,5,5,5, จะเป็น 98,5 และเก็บในตัวแปร distinctParent
        const distinctParent = [...new Set(valuesparent)];

        /// หาก distinctParent มีค่า lenght มากกว่าจะเข้าทำงานดังข้างล่างนี้
        if (distinctParent.length > 0) {
          /// loop สำหรับการ ตรวจสอบค่าของ การ Selected ของ Task ลูกว่ามีครบตามจำนวนหรือไม่หากครบให้ดึงแม่ออกจาก List ใน Deopdown list หากไม่ครบให้กลับมาเหมือนเดิม และ List จากการ Custom ใส่ใน Hidden field
          for (let i = 0; i < distinctParent.length; i++) {
            /// ล่างค่า List เก่าออกก่อน เอา List Show มาเป็นค่า Default
            setListTaskShow(listTaskDDL);

            /// filter listTaskDDL list ที่เก็บค่าถาวร จากค่า distinctParent ณ ตำแหน่งนั้นมาเก็บ ตัวแปร ParentCutall
            let ParentCutall = listTaskDDL.filter(
              (option) => option.parent_id === Number(distinctParent[i])
            );
            /// เอา ParentCutall มาเช็ค length ว่ามีจำนวนเท่าไร และเก็บตัวแปร Parentall
            let Parentall = ParentCutall.length;

            /// filter selected list ที่เก็บในtxtbox จากค่า distinctParent ณ ตำแหน่งนั้นมาเก็บ ตัวแปร ParentCutselect
            let ParentCutselect = selected.filter(
              (option) => option.parent_id === Number(distinctParent[i])
            );
            /// เอา ParentCutselect มาเช็ค length ว่ามีจำนวนเท่าไร และเก็บตัวแปร Parenselect
            let Parenselect = ParentCutselect.length;

            /// หากค่า Parent_id ของลูกใน txtbox เท่ากับ Parent_id ของลูกใน List ถาวร
            if (Parentall === Parenselect) {
              //console.log("Parent_id ที่เท่ากันในขณะนี้ = " + distinctParent[i]);
              let hdTasksubValue =
                document.getElementById("hd_selected_parent").value;
              hdTasksubValue = hdTasksubValue
                ? hdTasksubValue + "," + distinctParent[i]
                : distinctParent[i];
              document.getElementById("hd_selected_parent").value =
                hdTasksubValue;
            }
          }
        }

        const filterValue = document
          .getElementById("hd_selected_parent")
          .value.split(",")
          .map(Number);
        const filteredList = listTaskDDL.filter(
          (option) => !filterValue.includes(option.value)
        );
        setListTaskShow(filteredList);
      }
      /// หากไม่ใช่กาาร Select ลูกจะทำงานดังข้างล่างนี้
      else {
        const selectedMOM = selected.filter((option) => option.parent_id === 0);
        const selectedChildren = selected.filter(
          (option) => option.parent_id !== 0
        );
        const parentValues = selectedMOM.map((parent) => parent.value);
        const childOptionsToSelect = listTaskDDL.filter(
          (option) =>
            parentValues.includes(option.parent_id) ||
            selectedChildren.includes(option)
        );
        setSelectedOptionsTask(childOptionsToSelect);
        onChangevalue(childOptionsToSelect);

        let tex = cuttask(selectedMOM);
        let hdTaskValue = document.getElementById("hd_selected_parent").value;
        hdTaskValue = hdTaskValue ? hdTaskValue + "," + tex : tex;
        document.getElementById("hd_selected_parent").value = hdTaskValue;
        const filterValues = hdTaskValue.split(",").map(Number);
        const filteredList = listTaskDDL.filter(
          (option) => !filterValues.includes(option.value)
        );
        setListTaskShow(filteredList);
      }
    }
  };

  function cuttask(selected) {
    let sTask = "";
    if (selected.length > 0) {
      for (let i = 0; i < selected.length; i++) {
        sTask = sTask + (sTask === "" ? "" : ",") + selected[i].value;
      }
    }
    return sTask;
  }

  function cutparent(selected) {
    let sTask = "";
    if (selected.length > 0) {
      for (let i = 0; i < selected.length; i++) {
        sTask = sTask + (sTask === "" ? "" : ",") + selected[i].parent_id;
      }
    }
    return sTask;
  }

  return (
    <>
      <Select
        ref={refid}
        isMulti
        options={listTaskShow}
        value={selectedOptionsTask}
        closeMenuOnSelect={iscloseMenuOnSelect}
        components={animatedComponents}
        placeholder={SelectTextDefault}
        onChange={DDLTaskOptionChange}
        menuPortalTarget={document.body}
        isDisabled={isDisabled === undefined ? false : isDisabled}
        styles={{
          ...RSelect_Styles,
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
      />
      <input type="hidden" id="hd_selected_parent"></input>
    </>
  );
}

export default Select_TaskMultiGroup;
